<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 导出文章</div>-->
    <div class="boxCon">
      <div class="contLeft">
        <div class="leftLogo">
          <img class="jgLogo" :src="touXiang" alt="" v-if="touXiang">
          <img class="jgLogo" src="../../../assets/images/moren.jpeg" alt="" v-else>
          <div class="nikname">{{jgname}}</div>
        </div>
        <div class="titleBox">
          <div class="wzNum"><span>{{num}}</span>个文件夹</div>
          <div class="add" @click="cjWenJ">+创建文件夹</div>
        </div>
        <div class="wjList">
          <div class="wjlistSC">
            <div class="wjListBox" v-for="item in wjList" :key="item.id" @click="listBgc = item.id"
                 :class="{bgcList:listBgc === item.id}">
              <div class="listImg" v-if="listBgc === item.id"><img src="../../../assets/images/wjs.png" alt=""></div>
              <div class="listImg" v-else><img src="../../../assets/images/wj.png" alt=""></div>

              <div class="listTex">
                <div class="listTexTitle">{{item.foldername}}</div>
                <div class="listTexCont">{{item.sum}}篇文章</div>
              </div>
              <!--<div class="listDel" v-show="listBgc === item.id">-->
              <!--编辑-->
              <!--</div>-->
              <div class="listEdit" v-show="listBgc === item.id" @click="delWj(item.id,item.sum)">
                删除
              </div>
              <div style="clear:both;"></div>
            </div>
            <div class="wjListBox" @click="toPage('/home/hszBanKuai')">
              <div class="listImg"><img src="../../../assets/images/huishouzhanwj.png" class="img2"
                                        alt=""></div>
              <div class="listTex">
                <div class="listTexTitle" style="padding-top: 3px;">回收站</div>
                <div class="listTexCont">{{hszNum}}篇文章</div>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="contRight">
        <div class="rightSearch">
          <div class="searchInput">
            <input type="text" v-model="search" placeholder="请输入要搜索的文章标题">
            <div class="chuangZbtn" @click="to">创作文章</div>
            <div class="daoRbtn" @click="toPage('/home/daochuBanKuai')">文章导出到知识库</div>
            <div class="souS flex align-center justify-center" @click="keyWord"><img src="../../../assets/images/souS.png" alt="">搜索</div>
          </div>
          <div class="biaoQbox">
            <span class="sTit">所有标签:</span>
            <span class="sCon" @click="bqSous('')" :class="bgc === '' ? 'bgc' : ''">全部</span>
            <span class="sCon" v-for="item in bqList" :key="item.id"
                  :class="bgc === item.title ? 'bgc' : ''" @click="bqSous(item.title)">{{item.title}}</span>
          </div>
        </div>
        <div v-if="wzList.length > 0">
          <div class="neiConBox">
            <!--<div class="contBox" v-for="item in wzList" :key="item.id">-->
              <!--<div class="contList">-->
                <!--<div style="width: 100%;height: 210px;overflow: hidden">-->
                  <!--<div style="width: 100%;">-->
                    <!--<div class="contTitle" @click="yl(item.id)">{{item.title}}</div>-->
                    <!--<div class="contLine" @click="yl(item.id)"></div>-->
                  <!--</div>-->
                  <!--<div class="contTex" @click="yl(item.id)" v-html="item.content"></div>-->
                <!--</div>-->
                <!--<div class="contTime">{{item.addtime}}</div>-->
                <div class="cz-top">
                  <span class="s1">文章名称</span>
                  <span class="s2">操作</span>
                </div>
                <div class="contCZ" v-for="item in wzList" :key="item.id">
                  <div class="cz-title" @click="yl(item.id)">{{item.title}}</div>
                  <div class="contBtn">
                    <span class="contBtnBj" @click="copy(item.id)">复制</span>
                    <span class="contBtnBj" @click="delBj(item.id)">编辑</span>
                    <a class="contBtnBj" :href="'http://ysbpre.emof.cn/home/article/worddown/id/' + item.id">导出</a>
                    <span class="contBtnDel" @click="delWz(item.id)">删除</span>
                  </div>
                </div>
            <div class="pageBox">
              <span @click="page.pageNum = 1">首页</span>
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page.pageNum"
                :page-size="page.pageSize"
                layout="prev, pager, next"
                :total="page.pageTotal">
              </el-pagination>
              <span @click="page.pageNum = page.pageCount">尾页</span>
            </div>
              <!--</div>-->
            <!--</div>-->
          </div>

          <!--<div class="pageBox">-->
            <!--<span @click="page.pageNum = 1">首页</span>-->
            <!--<el-pagination-->
              <!--background-->
              <!--@size-change="handleSizeChange"-->
              <!--@current-change="handleCurrentChange"-->
              <!--:current-page.sync="page.pageNum"-->
              <!--:page-size="page.pageSize"-->
              <!--layout="prev, pager, next"-->
              <!--:total="page.pageTotal">-->
            <!--</el-pagination>-->
            <!--<span @click="page.pageNum = page.pageCount">尾页</span>-->
          <!--</div>-->
        </div>
        <div class="listNo" v-else>暂无文章.....</div>
      </div>
    </div>
    <noticeThree v-if="!isDetail" v-bind:idProps="id" v-bind:is-detail="isDetail"
                 @watchState="watchState"></noticeThree>
    <el-dialog
      title="导出到知识库"
      :visible.sync="daoR"
      width="30%"
      center
      custom-class="kuheShu"
      append-to-body
    >

      <!--<div class="ku">-->
      <!--<div class="title">-->
      <!--<img src="../../../assets/images/shuH.png" alt="">-->
      <!--<span>南朝四百八十寺</span>-->
      <!--</div>-->
      <!--<el-tree-->
      <!--:data="data"-->
      <!--:props="defaultProps"-->
      <!--@node-click="handleNodeClick"-->
      <!--&gt;</el-tree>-->
      <!--</div>-->
      <el-tree
        :data="zsgl"
        :props="props"
        ref="tree"
        node-key="id"
        show-checkbox
        :check-strictly="true"
        @check-change="handleCheckChange">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daoR = false" >取 消</el-button>
        <el-button type="primary" @click="daochu">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import noticeThree from '../../../components/noticeThree'

  export default {
    name: "wdwzBanKuai",
    data() {
      return {
        props: {
          label: 'label',
          children: 'folder_info'
        },
        touXiang: '',
        jgname:'',
        count: 1,
        isDetail: true,
        listBgc: '1',
        search: '',
        isAct: '',
        bgc: '',
        num: '',
        biaoQ: '',
        daoR: false, // 导入弹框
        wenZhangId: '', // 导出文章ID
        wjList: [], // 文件夹列表
        wzList: [], // 文章列表
        bqList: [], // 标签列表
        page: {
          pageNum: 1, // 当前页数
          pageSize: 12, // 每页显示条数
          pageTotal: 4, // 总条数
          pageCount: 1, // 总页数
        },
        zsgl: [],  //  知识库树
        zskid: '',
        zskwid: '',
        chiose: true,
        hszNum: '', // 回收站文章数量
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (!this.user) {
        this.$router.push("/login")
      }
      this.$emit('setIsAct', 6)
      this.GETWjList()
      this.getBqList()
      this.getKu()
      this.gethszList()
      this.touXiang = this.user.mthumb
      this.jgname = this.user.mnickname
    },
    methods: {
      resetChecked() {
        this.$refs.tree.setCheckedKeys([]);
      },
      handleCheckChange(data) {
        let arr = this.$refs.tree.getCheckedNodes()
        console.log(arr)
        if (arr.length > 1) {
          this.resetChecked()
          this.$refs.tree.setChecked(data.id, true);
        }
      },
      // daochuTan(id) {
        // this.daoR = true
        // this.wenZhangId = id
        // console.log(id)
      // },

      // 导出确定方法
      daochu(id) {
          var a = document.createElement('a');
          a.href = 'ysbpre.emof.cn/home/article/worddown/id/' + id;
          a.click();
      },
      // 获取库的树
      getKu() {
        this.$api.apiAdmin.GetAllFolder({
          mid: this.user.mid
        }).then(res => {
          console.log(res)
          res.data.map(item => {
            item.label = item.name
          })

          this.zsgl = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 获取回收站列表
      gethszList() {
        this.$api.apiAdmin.GetRecycleBin({
          mid: this.user.mid,
          keyword: '',
          page: 1,
          pagesize: 999999
        }).then(res => {
          this.hszNum = res.data.data.length

        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 文件夹列表
      GETWjList() {
        this.$api.apiAdmin.GetFolderList({
          mid: this.user.mid
        }).then(res => {
          console.log(res)
          this.wjList = res.data
          if (res.data[0]) {
            this.listBgc = res.data[0].id
            //根据第一个文件夹id获取文件夹内的文章列表
            this.GETWzList()
          }
          this.num = res.data.length
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 对应文件夹的文章列表
      GETWzList() {
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.listBgc) {
          this.listBgc = Number(this.$route.query.listBgc)
        } else {
          this.listBgc = this.listBgc
        }
        this.$api.apiAdmin.GetMyArticle({
          mid: this.user.mid,
          kind: this.listBgc,
          keyword: this.search,
          label: this.biaoQ,
          page: this.page.pageNum,
          pagesize: this.page.pageSize
        }).then(res => {
          this.wzList = res.data.data
          let List = res.data.data
          if (res.data.data[0]) {
            List.map(item => {
              // if (this.biaoQ !== '') {
              //   item.content = this.$tools.keywordscolorful(item.content, this.biaoQ)
              // }
              item.addtime = this.$tools.setDate(item.addtime * 1000)
            })
            this.page.pageTotal = res.data.pageinfo.count
            this.page.pageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
          }
        })
      },
      // 标签列表获取
      getBqList() {
        this.$api.apiAdmin.GetAllLable({
          mid: this.user.mid
        }).then(res => {
          console.log(res)
          this.bqList = res.data
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 编辑
      delBj(id) {
        this.$router.push({
          path: '/home/zncgBanKuai',
          query: {
            id: id,
            shengchengWZ: '98'
          }
        })
      },
      //
      to() {
        this.$router.push('/home/zncgBanKuai')
      },
      // 标签搜索
      bqSous(tex) {
        this.biaoQ = tex
        this.bgc = tex
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      // 创建文件夹
      cjWenJ() {
        this.$prompt('<h3>请输入新建文件的名称</h3>', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'cjBtn',
          cancelButtonClass: 'qxBtn',
          center: true,
          dangerouslyUseHTMLString: true,
          roundButton: true,
          inputPattern: /\S/,
          inputErrorMessage: '名字不能为空'
        }).then(({value}) => {
          this.$api.apiAdmin.AddFolder({
            mid: this.user.mid,
            title: value
          }).then(res => {
            console.log(res)
            this.$messageSuccess(res.msg);
            this.GETWjList()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      // 复制功能
      copy(id) {
        this.$api.apiAdmin.copyArticle({
          mid: this.user.mid,
          id: id,
        }).then(res => {
          console.log(res)
          this.$messageSuccess(res.msg);
          this.GETWzList()
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 删除文件夹
      delWj(id,num) {
        var str = '文件夹内存在文档，请删除文档后进行删除文件夹操作！'
        if(Number(num) === 0){
          str ='你确定要删除这个文件夹吗?'
        }
        this.$confirm('<p style="color: #0a2240;margin: 30px 0; ">'+ str +'</p>', '温馨提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          center: true,
          roundButton: true,
          cancelButtonClass: "scqx",
          confirmButtonClass: "scqd",
          showClose: false,
        }).then(() => {
          if(Number(num) < 1) {
            this.$api.apiAdmin.DelFolder({
              mid: this.user.mid,
              id: id
            }).then(res => {
              console.log(res)
              this.$messageSuccess(res.msg);
              // 文件夹列表
              this.GETWjList()
            }).catch(res => {
              this.$messageError(res.msg);
            })
          }else {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      // 文章删除
      delWz(id) {
        var len = this.wzList.length
        this.$confirm('<p style="color: #0a2240;margin: 30px 0; ">你确定要删除这篇文章吗?</p>', '温馨提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          center: true,
          roundButton: true,
          cancelButtonClass: "scqx",
          confirmButtonClass: "scqd",
          showClose: false,
        }).then(() => {
          this.$api.apiAdmin.delArticle({
            mid: this.user.mid,
            id: id
          }).then(res => {
            console.log(res)
            this.$messageSuccess(res.msg);
            if (this.page.pageNum > 1 && len === 1) {
              this.page.pageNum = this.page.pageNum - 1
              // 文件夹列表
              this.GETWjList()
            } else {
              // 文件夹的文章列表
              this.GETWzList()
              // 文件夹列表
              this.GETWjList()
            }
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 预览
      yl(id) {
        this.id = String(id)
        this.isDetail = false
      },
      // 详情关闭
      watchState(blon) {
        this.isDetail = blon
      },
      // 搜索
      keyWord() {
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      // 修改路径
      setPath() {
        this.$router.push({
          path: '/home/wdwzBanKuai',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
            listBgc: this.listBgc,
            biaoQ: this.biaoQ
          }
        })
      },
      // 点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      // 选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      toPage(path) {
        this.$router.push(path)
      },
      setAct(isAct) {
        this.isAct = isAct
      }

    },
    components: {
      noticeThree
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      listBgc() {
        this.page.pageNum = 1
        this.setPath()
      },
      $route() {
        this.GETWzList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgcList {
    background-color: rgba(255,255,255,.5) !important;
    padding-left: 11px !important;
  }

  .bgc {
    background-color: #fff !important;
    color: #0a2240 !important;
    border: none !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;

    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }

    .boxCon {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .contLeft {
        width: 200px;

        .leftLogo {
          width: 200px;
          height: 230px;
          background-color: #0a2240;
          text-align: center;
          border-radius: 4px;

          .jgLogo {
            width: 85px;
            height: 85px;
            border-radius: 42px;
            margin-top: 35px;
          }

          .nikname {

            margin: 15px;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
          }
        }

        .titleBox {
          min-width: 200px;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          border-radius: 4px;
          background-color: #0a2240;

          .wzNum {
            font-size: 14px;
            color: #fff;
            line-height: 52px;

            span {
              font-size: 16px;
              color: #fff;
              font-weight: bold;
            }
          }

          .add {
            width: 100px;
            font-size: 14px;
            color: #0a2240;
            cursor: pointer;
            text-align: center;
            //padding: 0 10px;
            height: 30px;
            line-height: 30px;
            border-radius: 15px;
            margin-top: 13px;
            background: #fff;
          }
        }

        .wjList {
          width: 100%;
          height: 569px;
          background-color: #0a2240;
          overflow: hidden;

          .wjlistSC {
            width: 235px;
            padding-right: 17px;
            height: 100%;
            overflow-y: scroll;

            .wjListBox {
              background-color: #0a2240;
              padding: 15px;
              cursor: pointer;

              .listImg {
                width: 30px;
                float: left;

                img {
                  width: 30px;
                  margin-top: 5px;
                }

                .img2 {
                  width: 30px;
                }
              }

              .listTex {
                width: 95px;
                float: left;

                .listTexTitle {
                  font-size: 18px;
                  font-weight: bold;
                  color: #ffff;
                  margin-top: -2px;
                  margin-bottom: 2px;
                  margin-left: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .listTexTitleHsz {
                  font-size: 18px;
                  font-weight: bold;
                  color: #fff;
                  margin-top: 13px;
                  margin-bottom: 2px;
                  margin-left: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .listTexCont {
                  font-size: 12px;
                  color: #fff;
                  margin-left: 10px;
                }
              }

              .listDel {
                float: right;
                font-size: 12px;
                color: #999999;
                background: url('../../../assets/images/edit.png') no-repeat left center;
                padding-left: 15px;
                background-size: 14px 14px;
                margin-top: 2px;
                cursor: pointer;
              }

              .listEdit {
                float: right;
                font-size: 12px;
                color: #fff;
                background: url('../../../assets/images/del.png') no-repeat left center;
                padding-left: 15px;
                background-size: 12px 12px;
                margin-top: 25px;
                /*margin-top: 8px;*/
                cursor: pointer;
              }
            }
          }

        }
      }

      .contRight {
        margin-left: 13px;
        flex: 1;

        .rightSearch {
          width: 1007px;
          height: 177px;
          background-color: #0a2240;
          border-radius: 10px;
          padding: 20px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          .searchInput {
            position: relative;
            height: 50px;

            input {
              width: 640px;
              padding-right: 100px;
              height: 48px;
              background-color: #f9f5f5;
              border-radius: 25px;
              border: solid 1px #f3e8e8;
              outline: none;
              text-indent: 30px;
              font-size: 16px;
              float: left;
              margin-right: 5px;
            }

            .chuangZbtn {
              width: 130px;
              height: 48px;
              background-color: #0a2240;
              border-radius: 25px;
              border: 1px solid #ff9600;
              font-size: 18px;
              color: #ff9600;
              float: left;
              margin: 0 10px;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
            }

            .daoRbtn {
              width: 168px;
              height: 48px;
              border-radius: 26px;
              font-size: 18px;
              float: left;
              border: 1px solid #ff9600;
              color: #ff9600;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
            }

            .souS {
              width: 121px;
              height: 48px;
              background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
              linear-gradient(
                  #a01212,
                  #a01212);
              background-blend-mode: normal,
              normal;
              border-radius: 25px;
              font-size: 18px;
              color: #fff;
              line-height: 48px;
              position: absolute;
              top: 0;
              left: 524px;
              cursor: pointer;
              img{
                width: 22px;
              }
            }
          }

          .biaoQbox {
            color: #99a2aa;
            font-size: 14px;
            margin-top: 15px;
            overflow: hidden;
            padding: 4px 0;

            .sCon {
              padding: 0px 10px;
              border: 1px solid #99a2aa;
              height: 28px;
              line-height: 26px;
              border-radius: 5px;
              margin-left: 10px;
              cursor: pointer;
              display: inline-block;
              margin-bottom: 6px;
            }
          }
        }

        .neiConBox {
          /*width: 100%;*/
          background-color: #fff;
          min-height: 625px;
          margin: 24px 10px;
          padding: 30px 20px;
          /*display: flex;*/
          /*margin-top: 24px;*/
          /*justify-content: flex-start;*/
          /*align-items: center;*/
          /*flex-wrap: wrap;*/
            .cz-top {
              width: 100%;
              padding-bottom: 4px;
              margin-bottom: 15px;
              border-bottom: 1px solid #ebebeb;
              display: flex;
              justify-content: space-between;
              .s1 {
                font-size: 16px;
                color: #666;
                line-height: 30px;
                margin-left: 6px;
              }
              .s2 {
                font-size: 16px;
                color: #666;
                line-height: 30px;
                margin-right: 94px;
              }
            }
          /*.contBox {*/
            /*width: 33.33%;*/
            /*margin-bottom: 24px;*/
            /*display: flex;*/
            /*justify-content: center;*/
            /*align-items: center;*/

            /*.contList {*/
              /*width: 93%;*/
              /*height: 300px;*/
              /*background-color: #ffffff;*/
              /*padding: 20px;*/
              /*!*margin-bottom: 30px;*!*/
              /*!*margin-right: 30px;*!*/
              /*.contTitle {*/
                /*font-size: 18px;*/
                /*font-weight: bold;*/
                /*color: #333333;*/
                /*!*display: -webkit-box;*!*/
                /*!*-webkit-box-orient: vertical;*!*/
                /*!*-webkit-line-clamp: 2;*!*/
                /*!*overflow: hidden;*!*/
                /*cursor: pointer;*/
                /*!*height: 48px;*!*/
              /*}*/

              /*.contLine {*/
                /*width: 29px;*/
                /*height: 2px;*/
                /*background-color: #0a2240;*/
                /*margin-top: 10px;*/
                /*margin-bottom: 10px;*/
                /*cursor: pointer;*/
              /*}*/

              /*.contTex {*/
                /*!*height: 138px;*!*/
                /*font-size: 14px;*/
                /*line-height: 24px;*/
                /*color: #666666;*/
                /*!*display: -webkit-box;*!*/
                /*!*-webkit-box-orient: vertical;*!*/
                /*!*-webkit-line-clamp: 4;*!*/
                /*overflow: hidden;*/
                /*cursor: pointer;*/

                /*p {*/
                  /*img {*/
                    /*width: 250px !important;*/
                    /*display: block;*/
                  /*}*/
                /*}*/

              /*}*/

              /*.contTime {*/
                /*width: 100%;*/
                /*height: 26px;*/
                /*height: 26px;*/
                /*font-size: 12px;*/
                /*color: #999;*/
                /*margin-top: 8px;*/
              /*}*/

              .contCZ {
                width: 100%;
                padding: 10px 0;
                display: flex;
                justify-content: space-between;
                .cz-title {
                  width: 650px;
                  font-size: 16px;
                  color: #333333;
                  cursor: pointer;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  padding-right: 30px;
                  background: url('../../../assets/images/Wicon.png') no-repeat left center;
                  /*background-position-y: 3px;*/
                  background-size: 19px 19px;
                  padding-left: 30px;
                }
                .cz-title:hover {
                  color: #0a2240;
                }
                .contBtn {
                  display: flex;
                  justify-content: flex-end;
                  .contBtnDel {
                    width: 50px;
                    height: 22px;
                    border-radius: 11px;
                    border: 1px solid #0a2240;
                    font-size: 14px;
                    color: #0a2240;
                    text-align: center;
                    line-height: 20px;

                    cursor: pointer;
                  }

                  .contBtnCopy {
                    width: 48px;
                    height: 18px;
                    border-radius: 9px;
                    border: solid 1px #0a2240;
                    font-size: 14px;
                    color: #0a2240;
                    text-align: center;
                    line-height: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                  }

                  .contBtnBj {
                    width: 50px;
                    height: 22px;
                    background-color: #e4e7f1;
                    border-radius: 11px;
                    border: 1px solid #0a2240;
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                    line-height: 22px;
                    cursor: pointer;
                    margin-right: 5px;
                  }
                }
              }
            }
          /*}*/
        /*}*/

        .pageBox {
          margin-top: 40px;
          display: flex;
          justify-content: center;
          margin-bottom: 80px;

          span {
            background-color: #fff;
            padding: 6px 10px;
            border: 1px solid #f2f2f2;
            font-size: 14px;
            border-radius: 6px;
            color: #666666;
            cursor: pointer;
          }

        }

        .listNo {
          //width: 906px;
          text-align: center;
          color: #0a2240;
          padding: 200px 0 334px 0;
          font-size: 14px;
          margin: 24px 0 0 10px;
          background-color: #fff;
        }
      }
    }
  }
  .dialog-footer button{
    width: 120px;
  }
</style>
